// Palette partagée par tous les écrans MFA (Activation, Vérification, Config, Admin, Challenge).
// Respecte le code couleur bleu officiel de l'application AnyBank.
export const mfaTheme = {
  primary: '#1967ba',       // Couleur principale bleu AnyBank
  primaryDark: '#124b7a',   // Titres, texte fort, boutons hover foncé
  primaryHover: '#1558a0',  // Hover des boutons pleins
  primaryLight: '#3C81CD',  // Bleu clair d'accent
  primaryBg: '#f0f6fc',     // Fonds de card "info" / conteneurs légers
  primaryBorder: '#cbe0f5', // Bordures de card "info"
  pageBg: '#f8fafc',        // Fond de page
  textMuted: '#4d5f72',     // Textes secondaires
  textMuted2: '#374759',
  inactive: '#999999',
} as const;